// Цель фоновой загрузки для редакторов ОТКРЫТОГО блока (п.24). Хук существует
// ради того, чтобы владельца картинки называла ТОЧКА ВЫЗОВА, а не очередь:
// очередь читала бы глобальное выделение и закоммитила бы в тот блок, который
// выделен сейчас, — а к моменту коммита это может быть уже другой блок.
//
// Пара id берётся из узкой проекции черновика (`useBlockDraftGate`), а не из
// стора: редакторы блока (`InfoBlockEditor`, `ImageSettings`) про стор не
// знают, и это их единственный источник «кто я». Оба рендерятся только для
// открытого блока — панель другого блока не существует.
import { useBlockDraftGate } from '../studio/BlockDraftContext'
import type { ApplyImageToBlock, BlockUploadTarget } from './uploadTask'

export const useOpenBlockUploadTarget = (
  apply: ApplyImageToBlock,
  /** Место внутри блока, если их несколько (id элемента дизайна): по нему
   *  `ImageUpload` отличает «то же место» от соседнего, на которое автор
   *  переключился, не размонтировав форму. */
  placeId?: string,
): BlockUploadTarget | undefined => {
  const { blockId, lessonId } = useBlockDraftGate()
  if (blockId === null || lessonId === null) return undefined
  return { blockId, lessonId, placeId, apply }
}
